import { getTenantSlug } from './api';

/**
 * Endereços do restaurante atual no domínio principal:
 *  - público (clientes):        /r/{slug}{p}       ex.: /r/bella-italia/conta
 *  - painel administrativo:     /painel/{slug}{p}  ex.: /painel/bella-italia/mesas
 */
export const publicPath = (p = '') => `/r/${getTenantSlug() ?? ''}${p}`;
export const staffPath = (p = '') => `/painel/${getTenantSlug() ?? ''}${p}`;
